import { AuditLog } from '../generated/gql-types';
import { create } from 'zustand';
import { GET_AUDIT_LOG_FOR_OBJECT } from './auditLog.gql';
import { getApolloClient } from '../lib/getApolloClient';
import dayjs from 'dayjs';

interface AuditLogState {
  auditLogs: AuditLog[];
  isLoading: boolean;
  setAuditLogs: (auditLogs: AuditLog[]) => void;
  fetchAuditLogsForObject: (objectId: string) => Promise<void>;
  getAuditLogsForObject: (objectId: string) => AuditLog[];
}

export const useAuditLogStore = create<AuditLogState>((set, get) => ({
  auditLogs: [],
  isLoading: false,
  setAuditLogs: (auditLogs: AuditLog[]) => set({ auditLogs }),
  fetchAuditLogsForObject: async (objectId: string) => {
    set({ isLoading: true });
    try {
      const { data } = await getApolloClient().query({
        query: GET_AUDIT_LOG_FOR_OBJECT,
        variables: { objectId },
        fetchPolicy: 'network-only',
      });
      set({ auditLogs: data.getAuditLogForObject });
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      set({ isLoading: false });
    }
  },
  getAuditLogsForObject: (objectId: string): AuditLog[] => {
    return get()
      .auditLogs.filter((auditLog) => auditLog.objectId === objectId)
      .sort((a, b) => {
        return (
          dayjs(parseInt(b.createdAt || '0')).valueOf() -
          dayjs(parseInt(a.createdAt || '0')).valueOf()
        );
      });
  },
}));
